<template>
  <div id="likeGame">
    <headerPage :title="title" :iconSrc='iconSrc' :headerSty='headerSty'></headerPage>
    <headerBg :headerBg="headerBg" class="headerBg"></headerBg>
    <gameImg :game='game'></gameImg>
    <div class="text">
        <div v-if="$route.query.type!='epic'">今年的新游里你最喜欢的就是这款游戏了吧，</div>
        <div v-if="$route.query.type=='epic' && !$route.query.shareRef">今年你白嫖的游戏中这款游戏最热门</div>
        <div v-if="$route.query.type=='epic' && $route.query.shareRef">今年'TA'白嫖的游戏中这款游戏最热门</div>
        <div v-if="$route.query.type=='steam' || $route.query.type=='psn'">
            你在这款游戏中一共度过了
            <span class="span1" :style="colorSty">{{data.playHour}}</span>
            <span class="span2" :style="colorSty">h</span>
        </div>
        <div v-if="$route.query.type=='xbox'">
            你在这款游戏你达成了
            <span class="span1" :style="colorSty">{{data.achievementProbability}}</span>
            <span class="span2" :style="colorSty">%</span>
            的成就率
        </div>
        <div v-if="$route.query.type!='epic'">超过了<span class="span1" :style="colorSty">{{data.exceedPlayer}}</span><span class="span2" :style="colorSty">%</span>的游民玩家</div>
        <div v-if="$route.query.type!='epic'">这是你今年在游戏中投资的最划算的一笔！<img src="../../assets/image/steam/right_big.png"></div>

        <div v-if="$route.query.type=='epic'">还有<span class="span1" :style="colorSty">{{data.yearHotPlayNumber}}</span><span class="span2" :style="colorSty">名</span>游民也很喜欢它</div>
        <div v-if="$route.query.type=='epic'">{{data.yearHotGameText}}<img src="../../assets/image/steam/right_big.png"></div>
      
    </div>
    <footerPage class="footerPage"></footerPage>
    <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
  </div>
</template>

<script>
import headerPage from '../../components/header.vue'
import gameImg from '../../components/gameImg.vue'
import footerPage from '../../components/footer.vue'
import footerBg from '../../components/footerBg.vue'
import headerBg from '../../components/headerBg.vue'
export default {
    props:{
        data:{
            type:[Object]
        }
    },
    data(){
        return {
            title:'最钟情的新游',
            iconSrc:require('../../assets/image/'+this.$route.query.type+'/'+this.$route.query.type+'_small.png'),
            headerSty:{
                padding:'7.2rem 0 0 1.95rem'
            },
            footerBg:{
                top:'24rem',
                height:'18rem',
                background: 'url('+require('../../assets/image/'+this.$route.query.type+'/'+'likeGameBg.png')+')',
                backgroundSize: '100%',
                backgroundRepeat:'no-repeat',
                backgroundPosition: 'top right',
                // backgroundAttachment: 'fixed',

            },

            headerBg:{
                height:'12.45rem',
                background: 'url('+require('../../assets/image/steam/headerBg.png')+')',
                backgroundRepeat:'no-repeat',
                backgroundSize:'300%',
                backgroundPosition: '8% 15%',
                // backgroundAttachment: 'fixed',
            },
            game:{},
            colorSty:{},
            

        }
       
    },
    mounted(){
       
        if(this.$route.query.type=='steam'){
            this.colorSty={
                color:'#5EE6FF'
            }
            this.$set(this.game,'gameImg',this.data.gameCover)
            this.$set(this.game,'gameName',this.data.gameName)
        }else if(this.$route.query.type=='psn'){
            this.colorSty={
                color:'#5EA6FF'
            }
            this.$set(this.game,'gameImg',this.data.gameCover)
            this.$set(this.game,'gameName',this.data.gameName)
        }else if(this.$route.query.type=='xbox'){
             this.colorSty={
                color:'#5EFF97'
            }
            this.$set(this.game,'gameImg',this.data.gameCover)
            this.$set(this.game,'gameName',this.data.gameName)
        }else if(this.$route.query.type=='epic'){
            this.colorSty={
                color:'#FF5E5E'
            }
            this.title='年度热门新游'
            this.$set(this.game,'gameImg',this.data.yearHotGameCover)
            this.$set(this.game,'gameName',this.data.yearHotGameName)
        }
        
    },
   
    methods:{
        getNumber(val){
            if(val){
                return val.toFixed(0)
            }
        }
    },
    components:{
        headerPage,
        gameImg,
        footerPage,
        footerBg,
        headerBg
    }
}
</script>

<style>

#likeGame .text{
    padding: 0 1.95rem;
    font-size: 0.7rem;
    font-family: Source Han Sans CN;
    color:rgba(255, 255, 255, 0.8);
}
#likeGame .text div{
    margin-bottom: 1.35rem;
}
#likeGame .text .span1{
    font-size: 1.4rem;
    font-family: Impact;
    color: #5EE6FF;
    margin-left: 0.3rem;
}
#likeGame .text .span2{
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    color: #5EE6FF;
    margin-left: 0.35rem;
    margin-right: 0.4rem;
}
 #likeGame .text>div:last-child{
        display: flex;
        align-items: end;
        justify-content: space-between;
    }
  
    #likeGame .text img{
        width: 1.8rem;
        height: 1.5rem;
        
    }
</style>